import { isDev } from '../utils/env';
import cast from '../types/chromecast-caf-receiver';

const appOptions = new cast.framework.CastReceiverOptions();

export const firstGenFirmwareVersion = '1.36.159268';
export const currentFirmwareVersion = navigator.appVersion.substring(
  navigator.appVersion.lastIndexOf('/') + 1
);

const { DEBUG, NONE } = cast.framework.LoggerLevel;

export const logLevel = isDev ? DEBUG : NONE;

export const CAST_MESSAGES = {
  CONSOLE: 'urn:x-cast:console',
  ERROR: 'urn:x-cast:error',
  CUSTOM: 'urn:x-cast:custom',
  REDIRECT: 'urn:x-cast:redirect',
  VCR: 'urn:x-cast:vcr',
};

/**
 * Text that represents the application status. It should meet internationalization
 * rules as it may be displayed by the sender application.
 * @type {string|undefined}
 */
appOptions.statusText = 'TV 2 PLAY';

// 4.3.8 needed to suppport HDR playback
appOptions.shakaVersion = '4.3.8';

/**
 * Indicate the receiver should not load the MPL player.
 */
appOptions.skipMplLoad = true;

appOptions.customNamespaces = {
  [CAST_MESSAGES.ERROR]: cast.framework.system.MessageType.JSON,
};

if (isDev) {
  /**
   * Set custom namespaces for communication between sender and receiver.
   * @type {object|undefined}
   */
  appOptions.customNamespaces = {
    [CAST_MESSAGES.CONSOLE]: cast.framework.system.MessageType.JSON,
    [CAST_MESSAGES.ERROR]: cast.framework.system.MessageType.JSON,
    [CAST_MESSAGES.CUSTOM]: cast.framework.system.MessageType.JSON,
    [CAST_MESSAGES.REDIRECT]: cast.framework.system.MessageType.JSON,
    [CAST_MESSAGES.VCR]: cast.framework.system.MessageType.JSON,
  };

  /**
   * Maximum time in seconds before closing an idle
   * sender connection. Setting this value enables a heartbeat message to keep
   * the connection alive. Used to detect unresponsive senders faster than
   * typical TCP timeouts. The minimum value is 5 seconds, there is no upper
   * bound enforced but practically it's minutes before platform TCP timeouts
   * come into play. Default value is 10 seconds.
   * @type {number|undefined}
   */
  appOptions.maxInactivity = 60000;
}

export default appOptions;
